import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luAgencyDivision = {
  actions: {
    async loadLuAgencyDivisionsForAgency(context, payload) {
      const url = `LuAgencyDivision/Agency/${payload}`
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luAgencyDivisions', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async loadLuAgencyDivisionsForUser(context, payload) {
      const url = 'LuAgencyDivision/UserAgency'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luAgencyDivisions', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luAgencyDivision
